export default "/images/vendor/flag-icon-css/flags/1x1/as.svg?7ae00cb9d6bf497132c195ddecfc9ecc";